import React, { useContext } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./Menu.css";
import { LanguageContext } from "../../context/LanguageContext";
import Logo from "../../assets/imgs/JG-Símbolo_Branco.svg";

const WHATSAPP =
  "https://wa.me/5584994514529?text=" +
  encodeURIComponent("Olá Jacques, vi seu perfil e gostaria de discutir um projeto de IA.");

const LINKEDIN = "https://www.linkedin.com/in/jacques-gomes-627739240/";

const copy = {
  en: {
    kicker: "AI Engineer · Natal, Brazil",
    headline: "Production AI for enterprise data.",
    contact: "Get in touch",
    resume: "Resume",
    close: "Close",
    open: "Open",
    focus: "Focus",
    links: [
      { to: "inicio", number: "01", label: "Home", hint: "Introduction" },
      { to: "build", number: "02", label: "What I build", hint: "Agents, data, LLMOps" },
      { to: "portfolio", number: "03", label: "Work", hint: "Selected cases" },
    ],
    chips: ["Multi-agent", "MCP", "Automation", "Data engineering", "LLMOps"],
  },
  pt: {
    kicker: "Engenheiro de IA · Natal, Brasil",
    headline: "IA de produção para dados empresariais.",
    contact: "Falar comigo",
    resume: "Currículo",
    close: "Fechar",
    open: "Abrir",
    focus: "Foco",
    links: [
      { to: "inicio", number: "01", label: "Início", hint: "Introdução" },
      { to: "build", number: "02", label: "O que eu construo", hint: "Agentes, dados, LLMOps" },
      { to: "portfolio", number: "03", label: "Trabalho", hint: "Casos selecionados" },
    ],
    chips: ["Multi-agente", "MCP", "Automação", "Engenharia de dados", "LLMOps"],
  },
};

const socials = [
  { href: "https://github.com/JacquesGomes/", label: "GitHub", icon: "uil uil-github-alt" },
  { href: LINKEDIN, label: "LinkedIn", icon: "uil uil-linkedin-alt" },
  { href: "https://www.instagram.com/jacquesgomess/", label: "Instagram", icon: "uil uil-instagram" },
  { href: WHATSAPP, label: "WhatsApp", icon: "uil uil-whatsapp" },
  { href: "mailto:jacquesgomes66@gmail.com", label: "Email", icon: "uil uil-envelope" },
];

const Menu = ({ toggleSidebar, isOpen, scrollToComponent }) => {
  const { language, changeLanguage } = useContext(LanguageContext);
  const t = copy[language] || copy.en;

  const go = (target) => {
    toggleSidebar();
    if (target === "build") {
      const el = document.getElementById("build-heading");
      if (el) window.scrollTo(0, el.getBoundingClientRect().top + window.scrollY - 88);
      return;
    }
    scrollToComponent(target);
  };

  return (
    <div className={`site-menu${isOpen ? " is-open" : ""}`} aria-hidden={!isOpen}>
      <div className="site-menu-inner">
          <div className="site-menu-bar">
            <img src={Logo} alt="Jacques Gomes" />
            <button type="button" className="site-menu-close" onClick={toggleSidebar} aria-label={t.close}>
              <CloseIcon fontSize="small" />
            </button>
          </div>

          <p className="site-menu-kicker">{t.kicker}</p>
          <h2 className="site-menu-headline">{t.headline}</h2>

          <nav className="site-menu-nav" aria-label="Mobile">
            {t.links.map((item) => (
              <button key={item.to} type="button" className="site-menu-card" onClick={() => go(item.to)}>
                <span className="site-menu-card-top">
                  <span className="site-menu-card-dot" />
                  <span className="site-menu-card-num">{item.number}</span>
                </span>
                <span className="site-menu-card-label">{item.label}</span>
                <span className="site-menu-card-hint">{item.hint}</span>
                <span className="site-menu-card-foot">
                  <span className="site-menu-card-dot" />
                  <span>{t.open} →</span>
                </span>
              </button>
            ))}
          </nav>

          <p className="site-menu-kicker site-menu-kicker-late">{t.focus}</p>
          <div className="site-menu-chips">
            {t.chips.map((chip) => (
              <span key={chip}>{chip}</span>
            ))}
          </div>

          <div className="site-menu-lang" role="group" aria-label="Language">
            <button type="button" className={language === "en" ? "is-active" : ""} onClick={() => changeLanguage("en")}>
              English
            </button>
            <button type="button" className={language === "pt" ? "is-active" : ""} onClick={() => changeLanguage("pt")}>
              Português
            </button>
          </div>

          <div className="site-menu-actions">
            <a className="main-btn" href={WHATSAPP} target="_blank" rel="noreferrer">
              {t.contact}
            </a>
            <a className="main-btn-alt" href={LINKEDIN} target="_blank" rel="noreferrer">
              {t.resume}
            </a>
          </div>

          <div className="site-menu-socials">
            {socials.map((item) => (
              <a key={item.label} href={item.href} target="_blank" rel="noreferrer" aria-label={item.label}>
                <i className={item.icon}></i>
              </a>
            ))}
          </div>
        </div>
    </div>
  );
};

export default Menu;
